import React, { useState, useEffect } from 'react';
import { Button, IconButton, TextField, Box } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import cartService from '../service/cartService'; // your service file
import { useAuth } from '../context/AuthContext';
import { useCart  } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { normalizeKey } from '../i18n';

const AddToCartButton = ({ product,selectedVariant}) => {
   const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const {
    email,
    name,
    familyName,
    givenName,
    userId,
    roles, 
    userTypes,
    partnerId,
    emailVerified,
  } = user || {};
  
   const { cart, setCart, loadCartFromServer } = useCart();
  
  {/* const [quantity, setQuantity] = useState(
  (cart?.find((item) => item.id === product.productId)?.quantity) || 0
);*/}

    // Save cart in localStorage whenever it changes
  useEffect(() => {
    
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);
  
  
      const isBackordered = selectedVariant?.inventoryStatus === "BACKORDERED";
    
    // Determine the text to display on the button
    const buttonText = isBackordered ? "Next-Day Delivery" : "Add to Cart";

  const backorderedStyle = {
    backgroundColor: '#FFB74D',   // Soft orange
    color: '#4E342E',             // Deep brown text for contrast     color: '#4E342E',  

    '&:hover': {
        backgroundColor: '#FFA726', 
    },
};

  
  const addcartStyle = {
    backgroundColor: '#4D7B2B',   // Soft green 81C784
    color: '#FFFFFF',             // Dark green text

    '&:hover': {
        backgroundColor: '#66BB6A',
    },
};


  
  const updateCart = async (newQty) => {
    
    if(!user){
      navigate("/login");
      return;
    }
   /* setQuantity(newQty);
    setCart((prev) => {
      const existing = prev?.find((item) => item.id === product.productId);
      if (existing) {
        if (newQty === 0) {
          return prev.filter((item) => item.id !== product.id);
        } else {
          return prev.map((item) =>
            item.id === product.productId ? { ...item, quantity: newQty } : item
          );
        }
      } else {
        return [...prev, { ...product, quantity: newQty }];
      }
    });*/

    // Call service
  //  if (newQty > 0) {
    //  alert(selectedVariant);
  //    alert(selectedVariant?.variantId);
    
    
     
  /*const item = cart.find((p) => p.productVariantId === selectedVariant.variantId);
  if (!item) return;

  const updatedCart = cart.map((p) =>
    p.productVariantId === selectedVariant.variantId? { ...p, quantity: p.quantity + 1 }
      : p
  );

  setCart(updatedCart);
      localStorage.setItem('cart', JSON.stringify(updatedCart));*/
    
    
      /*  setCart((prev) => {
      const existing = prev?.find((item) => item.productVariantId === selectedVariant.variantId);
      if (existing) {
        if (newQty === 0) {
          return prev.filter((item) => item.productVariantId !== selectedVariant.variantId);
        } else {
          return prev.map((item) =>
            item.productVariantId === selectedVariant.variantId ? { ...item, quantity: newQty } : item
          );
        }
      }
    });
    */


    
    if (cart  && cart.length > 0) { 
    if (cart[0]?.inventoryStatus !== selectedVariant.inventoryStatus) {
        
        alert(`${selectedVariant.inventoryStatus} products are added separately!!`);
        
        return;
    }
}


    const addToCartDTO = {
                userId: userId, // Replace with logged-in user ID
                productId: product.productId,
                quantity: newQty,
                variantId: selectedVariant.variantId,
                warehouseId: selectedVariant.warehouseId,
                inventoryStatus: selectedVariant.inventoryStatus
            };
    
    try{
        await cartService.addOrUpdateToCart(addToCartDTO);
    } catch (err) {
  if (err.response) {
    alert(err.response.data.message || "Bad Request");
  } else {
    alert("Network error");
  }
}
  
    await loadCartFromServer();
    //     localStorage.setItem('cart', JSON.stringify(cart));
    // console.log("adter add ", cart);
      // setQuantity((cart?.find((item) => item.id === product.productId)?.quantity)|| 0);
  /*  } else {
        const addToCartDTO = {
                userId: userId, 
                productId: product.productId,
                quantity: newQty,
                variantId: selectedVariant.variantId
            };
      cartService.addOrUpdateToCart(addToCartDTO); */
    //  loadCartFromServer();
     // cartService.removeFromCart(product.productId);
//    }
  };

  const handleAdd = () => updateCart(1);
 /* const handleRemove = () => {
    if (quantity > 0) updateCart(- 1);
  };

  const handleChange = (e) => {
    const val = parseInt(e.target.value) || 0;
    if (val >= 0) updateCart(val);
  };
*/

   return (
     
      <Button
            variant="contained"
            // Apply custom styles when backordered
            sx={isBackordered ? backorderedStyle : addcartStyle } 
            
            // Optionally disable the button entirely
          //  disabled={isBackordered}
            
            // Note: updateCart(1) is your function to handle cart logic
            onClick={() => {
               // if (!isBackordered) {
                    // Only update the cart if not backordered
                    updateCart(1); 
              //  }
            }}
        >
          
 {t(normalizeKey(buttonText), buttonText)}
        </Button>

);

 {/*  return quantity === 0 ? (
  ) : (
    <Box display="flex" alignItems="center" mt={1}>
      <IconButton onClick={handleRemove}><Remove /></IconButton>
      <TextField
        type="number"
        size="small"
        value={quantity}
        onChange={handleChange}
        inputProps={{ min: 0, style: { width: 40, textAlign: 'center' } }}
      />
      <IconButton onClick={handleAdd}><Add /></IconButton>
    </Box>
  ); */}
};

export default AddToCartButton;
